module.exports = __webpack_public_path__ + "img/module_jcxx_icon.5b6ec85a.png";